

import { Component, Input } from "@angular/core";

@Component({
    selector: 'row-view',
    template: ` <div class="row mt-2">
                    <strong class="col-12 col-md-6 col-lg-4 col-xl-4"> {{ heading }} :</strong>
                    <div class="col-12 col-md-6 col-lg-8 col-xl-4">
                        {{ text }}
                    </div>
                </div>`
})
export class RowViewComponent {
    @Input() heading: string;
    @Input() text: string;
}
